import { FC, useMemo } from "react";
import { observer } from "mobx-react-lite";
import styled from "@emotion/styled";
import { MDSFadeBottom, MDSPanelContainer, AppearAnimator } from "@/mds";
import { AudioRecordingsListPageHeader } from "@/pages/audio-recordings/list/audio-recordings-list-page-header";
import { useTabPageStore } from "@/components/layout/components/tab-bar/use-tab-page-store";
import { AudioRecordingsListPageList } from "@/pages/audio-recordings/list/audio-recordings-list-page-list";

export const AudioRecordingsPage: FC = observer(() => {
  const page = useTabPageStore("audioRecordingsListPage");
  page.useEffects();

  const isVisible = useMemo(() => page.subscriptionInitialized, [page.subscriptionInitialized]);

  return (
    <PageWrapper visible={isVisible}>
      <AudioRecordingsListPageHeader />
      <MDSPanelContainer>
        <AudioRecordingsListPageList />
        <MDSFadeBottom />
      </MDSPanelContainer>
    </PageWrapper>
  );
});

const PageWrapper = styled(AppearAnimator)({
  position: "relative",
  height: "100%",
  display: "flex",
  flexDirection: "column",
});
